import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  downloadApp: {
    id: 't.downloadApp',
    defaultMessage: 'Download the App',
  },
  openLinkInBrowser: {
    id: 't.openLinkInBrowser',
    defaultMessage: 'Open Link in Browser',
  },
  openingLink: {
    id: 't.openingLink',
    defaultMessage: 'Opening Link...You will be directed in a few moments.',
  },
  noAppYet: {
    id: 't.noAppYet',
    defaultMessage: "Don't have the app yet?",
  },
  branchError: {
    id: 't.branchError',
    defaultMessage:
      'Sorry! we are facing some issues opening Pandora desktop app right now. Please try again later.',
  },
} as const);

export const locationConstants = Object.freeze({
  sourceCard: 'Source card',
  headerDropDown: 'Header dropdown',
} as const);

export const desktopActions = Object.freeze({
  GENERATE_AND_GO_TO_BRANCH_LINK: 'GENERATE_AND_GO_TO_BRANCH_LINK',
} as const);

export const desktopErrorCodes = Object.freeze({
  ERROR_CREATING_BRANCH_LINK: 'ERROR_CREATING_BRANCH_LINK',
} as const);

export const numberOfBranchTries = 3;
